const readAiFallbackCardsFromDom = () => {
  const el = document.getElementById('document-container');
  if (!el) return false;

  if (
    el.getAttribute('data-case-experience--case-viewer-ai-fallback-cards-value') === 'true' ||
    el.getAttribute('data-case-viewer-ai-fallback-cards-value') === 'true'
  ) {
    return true;
  }

  const raw =
    el.getAttribute('data-case-experience--case-viewer-document-user-state-value') ||
    el.getAttribute('data-case-viewer-document-user-state-value');
  if (!raw) return false;

  try {
    const state = JSON.parse(raw);
    return state?.root?.aiFallbackCards?.value === true || state?.root?.aiFallbackCards === true;
  } catch {
    return false;
  }
};

// ponytail: mirrors RootSectionSiblings.hidden_ai_display_flag_for_case_path in Ruby; enforced by case_path_visibility_sync_spec.
export const casePathHiddenAiDisplayFlag = ({ vpeEnabled, aiFallbackCards }) => {
  if (aiFallbackCards) return 'aiOn';
  return vpeEnabled ? 'aiOff' : 'aiOn';
};

export const rootSectionVisibleOnCasePath = (aiDisplayFlag, context) => {
  const flag = aiDisplayFlag == null || aiDisplayFlag === '' ? undefined : aiDisplayFlag;
  if (context.aiFallbackCards) return flag !== 'aiOn';
  if (flag === undefined) return true;
  return flag !== casePathHiddenAiDisplayFlag(context);
};

export const getCasePathContextFromDom = () => {
  const el = document.getElementById('document-container');
  if (!el) return { vpeEnabled: false, aiFallbackCards: false };

  const vpeFlag =
    el.getAttribute('data-case-experience--case-viewer-vpe-enabled-value') ??
    el.getAttribute('data-case-viewer-vpe-enabled-value');
  const aiEnabled =
    el.getAttribute('data-case-experience--case-viewer-ai-enabled-value') ??
    el.getAttribute('data-case-viewer-ai-enabled-value');
  const vpeEnabled = vpeFlag === 'true' && aiEnabled === 'true';

  let aiFallbackCards = readAiFallbackCardsFromDom();

  return { vpeEnabled, aiFallbackCards };
};

export const getNextVisibleDocSection = (currentSection, context = getCasePathContextFromDom()) => {
  if (!currentSection) return null;
  let section = currentSection.nextElementSibling;
  while (section) {
    if (section.classList.contains('doc-section')) {
      const flag = section.getAttribute('data-ai-display-flag');
      if (rootSectionVisibleOnCasePath(flag, context)) {
        return section;
      }
    }
    section = section.nextElementSibling;
  }
  return null;
};

export const refreshCaseNextRootSectionUidsInDom = () => {
  const context = getCasePathContextFromDom();
  document
    .querySelectorAll(
      '.doc-section[data-level="1"], [data-case-experience--case-viewer-target="section"]',
    )
    .forEach((section) => {
      const next = getNextVisibleDocSection(section, context);
      if (next?.dataset?.uid) {
        section.dataset.caseNextRootSectionUid = next.dataset.uid;
      } else {
        delete section.dataset.caseNextRootSectionUid;
      }
    });
};
